const validationErrors = {
  accepted: ':attribute måste vara godkännt.',
  alpha: ':attribute får bara innehålla bokstäver.',
  alpha_dash: ':attribute får bara innehålla alfanumeriska tecken, bindestreck och understreck.',
  alpha_num: ':attribute måste vara alfanumeriskt.',
  between: ':attribute måste vara mellan :min och :max.',
  confirmed: ':attribute överensstämmer inte.',
  email: ':attribute är inte en korrekt e-postadress.',
  date: ':attribute är inte ett korrekt datum.',
  def: ':attribute innehåller fel.',
  digits: ':attribute måste vara :digits siffror.',
  different: ':attribute och :different måste vara annorlunda.',
  'in': ':attribute är inte korrekt val.',
  integer: ':attribute får bara innehålla siffror.',
  min: {
    numeric: ':attribute måste vara högre än :min.',
    string: ':attribute måste vara längre än :min tecken.',
  },
  max: {
    numeric: ':attribute får inte vara högre än :max.',
    string: ':attribute får inte vara längre än :max tecken.',
  },
  not_in: 'Det valda :attribute är ogiltigt.',
  numeric: ':attribute måste vara ett nummer.',
  required: ':attribute måste vara ifyllt.',
  required_if: ':attribute måste vara ifyllt när :other är :value.',
  required_without: ':attribute måste vara ifyllt när :field är tomt',
  same: ':attribute och :same måste matcha.',
  size: {
    numeric: ':attribute måste vara :size.',
    string: ':attribute måste vara :size tecken långt.',
  },
  string: ':attribute får bara innehålla text.',
  url: ':attribute har ett felaktigt format.',
  regex: ':attribute har ett felaktigt format.',
  archivable: ':attribute måste vara ett datum eller ett booleskt värde',
  attributes: {},
};

export {validationErrors};



// WEBPACK FOOTER //
// ./src/helpers/lang.js